// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ResetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ResetIcon" ref={forwardedRef} {...props}>
      <path d="M3.5 8.25h5v-1.5H6.042a5 5 0 0 1 3.452-1.379 5.003 5.003 0 0 1 5.006 5c0 2.76-2.24 5-5.006 5a5 5 0 0 1-3.526-1.45l-1.062 1.06a6.5 6.5 0 0 0 4.588 1.89 6.503 6.503 0 0 0 6.506-6.5c0-3.59-2.913-6.5-6.506-6.5A6.5 6.5 0 0 0 5 5.671V3.25H3.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ResetIcon = /* @__PURE__ */ Object.assign(ResetIconComponent, {
  displayName: 'ResetIcon',
});
